export default "__VITE_ASSET__BrxbMd0u__"